import { message, PageHeader, Popconfirm, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import {ButtonItem, TableItem} from "../../../Components/Items";
import moment from "moment";
import 'moment/locale/es'
import { connect } from "react-redux";
import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import AgregarPerfil from "./AgregarPerfil/AgregarPerfil";
import EditarPerfil from "./EditarPerfil/EditarPerfil";

moment.locale('es')

class Perfiles extends Component {
  state = {
    todasPerfiles: [],
    loading: false,
    modalAgregarPerfil: false,
    modalEditarPerfil: false,
    modalEditarPerfilId: null
  }
  componentDidMount() {
    this.consultarPerfiles();
  }

  consultarPerfiles() {
    this.setState({ loading: true });
    axios
    .post(
      "perfiles/selectTodosPerfiles",
      { usuarioPrincipal: this.props.usuarioPrincipal },
      {
        headers: this.props.headersToken,
      }
    )
    .then((res) => {
      if (res.data.status === 404) {
        this.setState({ loading: false });
      } else {
        this.setState({
          loading: false,
          todasPerfiles: res.data.map(value => {
            return {...value, accion: { _id: value._id, estado: value.estado }}
          }),
        });
      }
    })
    .catch(() => this.setState({ loading: false }));
  }

  deshabilitarPerfil(value) {
    axios
      .post(
        "perfiles/deshabilitarPerfil",
        { perfilId: value, usuarioPrincipal: this.props.usuarioPrincipal },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Perfil deshabilitado");
        } else {
          message.error("Sucedio un eror y no se pudo deshabilitar");
        }
        this.consultarPerfiles();
      });
  }
  habilitarPerfil(value) {
    axios
      .post(
        "perfiles/habilitarPerfil",
        { perfilId: value, usuarioPrincipal: this.props.usuarioPrincipal },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Perfil habilitado");
        } else {
          message.error("Sucedio un eror y no se pudo habilitar");
        }
        this.consultarPerfiles();
      });
  }
  abrirAgregarPerfil() {
    this.setState({ modalAgregarPerfil: true });
  }
  cerrarAgregarPerfil() {
    this.setState({ modalAgregarPerfil: false });
    this.consultarPerfiles();
  }
  abrirEditarPerfil(id) {
    this.setState({ modalEditarPerfil: true, modalEditarPerfilId: id });
  }
  cerrarEditarPerfil() {
    this.setState({ modalEditarPerfil: false });
    this.consultarPerfiles();
  }

  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
      },
      {
        title: "Descripcion",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        },
      },
      {
        title: "Fecha",
        dataIndex: "createdAt",
        key: "createdAt",
        responsive: ["md"],
        sorter: (a, b) => {
          if (moment(a.createdAt) < moment(b.createdAt)) {
            return -1;
          }
          if (moment(a.createdAt) > moment(b.createdAt)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale('es').format('ll'),
      },
      {
        title: 'Acción',
        dataIndex: 'accion',
        key: 'accion',
        align: 'center',
        render: (value) => (
          <div className="acciones-container">
            <Tooltip title={this.props.permisoEditarPerfil ? "Editar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.props.permisoEditarPerfil && this.abrirEditarPerfil(value._id)}
                disabled={!this.props.permisoEditarPerfil}
              />
            </Tooltip>
            {value.estado === 1 ? (
              <Popconfirm
                title="Seguro que quieres deshabilitar este perfil"
                onConfirm={() => this.deshabilitarPerfil(value._id)}
                okText="Si"
                cancelText="No"
                disabled={!this.props.permisoDeshabilitarPerfil}
              >
                <Tooltip title={this.props.permisoDeshabilitarPerfil ? "Deshabilitar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                    disabled={!this.props.permisoDeshabilitarPerfil}
                  />
                </Tooltip>
              </Popconfirm>
            ) : (
              <Popconfirm
                title="Seguro que quieres habilitar este perfil"
                onConfirm={() => this.habilitarPerfil(value._id)}
                okText="Si"
                cancelText="No"
                disabled={!this.props.permisoDeshabilitarPerfil}
              >
                <Tooltip title={this.props.permisoDeshabilitarPerfil ? "Habilitar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                    disabled={!this.props.permisoDeshabilitarPerfil}
                  />
                </Tooltip>
              </Popconfirm>
            )}
          </div>
        ),
      }
    ]
    return (
      <>
        <PageHeader
          title="Perfiles"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={this.props.permisoAgregarPerfil ? [
            <ButtonItem
              olivo
              className="botonAgregar"
              type="primary"
              key="agregarPerfil"
              onClick={this.abrirAgregarPerfil.bind(this)}
            >
              Agregar Perfil
            </ButtonItem>,
          ] : []}
        />
        <TableItem
          size='small'
          dataSource={this.state.todasPerfiles}
          columns={columns}
          loading={this.state.loading}
          pagination={false}
        />
        <AgregarPerfil
          visible={this.state.modalAgregarPerfil}
          cerrarAgregarPerfil={this.cerrarAgregarPerfil.bind(this)}
        />
                        <EditarPerfil
          visible={this.state.modalEditarPerfil}
          id={this.state.modalEditarPerfilId}
          cerrarEditarPerfil={this.cerrarEditarPerfil.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    usuarioPrincipal: state.user.usuarioPrincipal,
    empresaId: state.empresa.id,
    permisoAgregarPerfil:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a2313d3903358dc7da8a89a"
      )?.activado,
    permisoEditarPerfil:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a2313df903358dc7da8a89b"
      )?.activado,
    permisoDeshabilitarPerfil:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a2313fa903358dc7da8a89d"
      )?.activado,
  };
};

export default connect(mapStateToProps)(Perfiles);